import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import { URL,api } from '../../api';
import Modalexpercommentbacktexscore from './Modalexpercommentbacktexscore';
import Modalexpercommentscoreshow from './Modalexpercommentscoreshow';



export default class Commentexchecklistpsf extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbn:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',

   typelevel:'',
   listscore:[],
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
this.listscore = this.listscore.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ typelevel:this.props.typelevel,
                       expert_id:this.props.expert_id,

         })
      setTimeout(() => {
       
        api.get('registercon/selectArticlespfexcheckwhereid/'+this.props.id_emp+'/'+this.props.id_articlepsf+'/'+localStorage.getItem('iduser'), )
        .then(res => {
          console.log(res);
       
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

     // this.listscore();

  }

  list() {
 
      setTimeout(() => {
        api.get('registercon/selectArticlespfexcheckwhereid/'+this.props.id_emp+'/'+this.props.id_articlepsf+'/'+localStorage.getItem('iduser'), )
        .then(res => {
          console.log(res);
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }


   listscore() {
 
      setTimeout(() => {
        api.get('registercon/selectscoreallex' )
        .then(res => {
          console.log(res);
          this.setState({ listscore: res.data})
        }) 

      }, 0);

  }





    render() {
        

        return (
            <>
           <MDBTable small>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ผลงานสำหรับตรวจ</th>
          <th>วันที่ส่งผลงาน</th>
          {/* <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ปรับแก้ไข</th> */}
          <th>การประเมิน</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbn.map((commentbn,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        {/* <td>{commentbn.fileword}</td> */}
                                                  <td>{commentbn.send_uploadewordex !== null ? <>
                          <tr>
                             <td><a href={`${this.state.url+commentbn.send_uploadepdfex}`}  target="_blank"><p className="red-text"><MDBBtn color="unique" size='sm' className="rounded-pill" ><MDBIcon far icon="file-pdf" /> PSF01 .pdf</MDBBtn></p> </a></td>
                             <td><a href={`${this.state.url+commentbn.send_uploadepdfex2}`}  target="_blank"><p className="red-text"><MDBBtn color="unique" size='sm' className="rounded-pill" ><MDBIcon far icon="file-pdf" /> PSF02 .pdf</MDBBtn></p> </a></td>
                             <td><a href={`${this.state.url+commentbn.send_uploadepdfex3}`}  target="_blank"><p className="red-text"><MDBBtn color="unique" size='sm' className="rounded-pill" ><MDBIcon far icon="file-pdf" /> PSF03 .pdf</MDBBtn></p> </a></td>
                             <td><a href={`${this.state.url+commentbn.send_uploadepdfex4}`}  target="_blank"><p className="red-text"><MDBBtn color="unique" size='sm' className="rounded-pill" ><MDBIcon far icon="file-pdf" /> PSF04 .pdf</MDBBtn></p> </a></td>
                          </tr>

                            {/* <a href={`${this.state.url+commentbn.send_uploadewordex}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .word</p> </a>
                            <a href={`${this.state.url+commentbn.send_uploadepdfex}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .pdf</p> </a> */}
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentbn.dateaddex}</td>

                   
                        <td>
                         {commentbn.scoreall !== null ?<><span className="blue-text font-weight-bold">ประเมินผลแล้ว</span></>:<><Modalexpercommentbacktexscore id_articlepsf={commentbn.id_articlepsf} id_empex={commentbn.id_empex} idarticleex={commentbn.idarticleex} typelevel={this.state.typelevel} nameuserex={commentbn.nameuserex} expert_id={this.state.expert_id} list={this.list}  /></>} 
                        <br/>
                         {commentbn.scoreall !== null ?<> <Modalexpercommentscoreshow  id_articlepsf={commentbn.id_articlepsf} id_expert={commentbn.expert_idcr} typelevel={this.props.typelevel} idarticleexcr={commentbn.idarticleex} nameuserex={commentbn.nameuserex} list={this.list}  /> </>:<></>}
                          {/* {commentbn.statusbn ==='2' || commentbn.statusbn ==='0'  ?<>แจ้งกลับแล้ว</>:<>
                          {commentbn.statusbn ==='3' ?<>ส่งกลับแล้ว</>:<></> }
                               Modalexpercommentscoreshow
                          </>}
                        
                        
                        {} */}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


